import { render, staticRenderFns } from "./doc-item-info.vue?vue&type=template&id=0ad53812&scoped=true"
import script from "./doc-item-info.vue?vue&type=script&lang=js"
export * from "./doc-item-info.vue?vue&type=script&lang=js"
import style0 from "./doc-item-info.vue?vue&type=style&index=0&id=0ad53812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad53812",
  null
  
)

export default component.exports